import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import moment from 'moment-timezone';
import { Subscription } from 'rxjs';
import { DatetimePickerOptions } from 'src/app/core/interfaces/datetime-picker-options';
import { DateManager } from 'src/app/core/managers/date.manager';

@Component({
  selector: 'app-datetime-picker',
  templateUrl: './datetime-picker.component.html',
  styleUrls: ['./datetime-picker.component.scss']
})
export class DatetimePickerComponent implements OnInit {
  @ViewChild('date', { static: true }) date: any;

  @Input() options: DatetimePickerOptions;
  @Input() control: FormControl = new FormControl(null);
  controlSub: Subscription;


  form: FormGroup = new FormGroup({
    date: new FormControl(null),
    time: new FormControl(null)
  });

  date_control = new FormControl(new Date());
  time_control = new FormControl('00:00');
  am_pm_control = new FormControl('am');

  @Output() change: EventEmitter<string> = new EventEmitter<string>();

  hours: Array<number>;
  minutes: Array<number>;

  constructor() {
    moment.tz.setDefault('America/Bogota');
    moment.locale('es');
    const default_options = {
      label_date: 'Fecha',
      label_time: 'Hora',
      mandatory: true,
      hours_step: 1,
      minutes_step: 1,
      militar: false,
      filter: () => true
    };

    this.options = { ...default_options, ...this.options };

    this.controlSub = this.control.valueChanges.subscribe(
      (changes) => {
        const date = moment(changes).startOf('day');
        const time = moment.duration(-(date.diff(moment(changes))));

        this.date_control.setValue(date.toDate());


        if (time.hours() > 12 && !this.options.militar) {
          this.am_pm_control.setValue('pm');
          const hh = `${time.hours() - 12}`.padStart(2, '0');
          const mm = `${time.minutes()}`.padStart(2, '0');
          this.time_control.setValue(`${hh}:${mm}`);
        } else {
          const hh = `${time.hours() - 12}`.padStart(2, '0');
          const mm = `${time.minutes()}`.padStart(2, '0');
          this.time_control.setValue(`${hh}:${mm}`);
        }



        this.form.get('time').setValue(time);
        this.form.get('date').setValue(date);
      }
    );
  }

  ngOnInit() {
    this.initTimes();

    if (!!this.control.value) {
      const date = moment(this.control.value).startOf('day');
      const time = moment.duration(-(date.diff(moment(this.control.value))));

      this.date_control.setValue(date.toDate());

      if (time.hours() > 12 && !this.options.militar) {
        this.am_pm_control.setValue('pm');
        const hh = `${time.hours() - 12}`.padStart(2, '0');
        const mm = `${time.minutes()}`.padStart(2, '0');
        this.time_control.setValue(`${hh}:${mm}`);
      } else {
        const hh = `${time.hours() - 12}`.padStart(2, '0');
        const mm = `${time.minutes()}`.padStart(2, '0');
        this.time_control.setValue(`${hh}:${mm}`);
      }

      this.form.get('time').setValue(time);
      this.form.get('date').setValue(date);
    } else {
      this.form.get('time').setValue(moment.duration('00:00'));
      this.form.get('date').setValue(moment().startOf('day'));
      this.emitCurrentDateTime();
    }
  }

  private initTimes(): void {
    if (!this.options.hours_step)
      this.options.hours_step = 1;
    if (!this.options.minutes_step)
      this.options.minutes_step = 1;

    let size = this.options.militar ? 24 : 12;
    this.hours = Array(size)
      .fill(1)
      .map((_, index) => this.generator(index, this.options.hours_step, size))
      .filter(hour => hour !== undefined);

    size = 60;
    this.minutes = Array(size)
      .fill(1)
      .map((_, index) => this.generator(index, this.options.minutes_step, size))
      .filter(minute => minute !== undefined);
  }

  private generator(index: number, steep: number, size: number): number {
    const time = index * steep;
    return time <= size ? time : undefined;
  }

  changeDate(event: any) {
    const date = event.value;
    // El toString asegura una nueva instancia.
    const _moment_instance = moment(date.toString());
    this.form.get('date').setValue(_moment_instance);
    this.emitCurrentDateTime();
  }

  changeTime(event: any) {
    const time = event.value;
    const _duration_instance = moment.duration(time);

    // Agregar 12 horas si el formato es civil y pm
    if (!this.options.militar && this.am_pm_control.value == 'pm') {
      _duration_instance.add('12:00:00');
    }

    this.form.get('time').setValue(_duration_instance);
    this.emitCurrentDateTime();
  }

  changeTimeAmPm(event: any) {
    const value = event.value;
    const time = this.form.get('time').value;
    value == 'am' ? time.add('-12:00') : time.add('12:00');
    this.form.get('time').setValue(time);
    this.emitCurrentDateTime();
  }

  emitCurrentDateTime() {
    const date = this.form.get('date').value as moment.Moment;
    const time = this.form.get('time').value as moment.Duration;
    const _datetime = moment(date.toString()).add(time);

    // Asignar el valor de fecha a un formControl si hay un control para usar como output
    this.control.setValue(DateManager.formatDate(new Date(_datetime.toString())));
    this.change.emit(_datetime.toISOString(true));
  }

  ngOnDestroy() {
    if (this.controlSub) this.controlSub.unsubscribe();
  }
}
